"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootBoxAction = void 0;
var LootBoxAction;
(function (LootBoxAction) {
    LootBoxAction["SET_MINI_GAME"] = "set_mini_game";
    LootBoxAction["SET_PRIZE"] = "set_prize";
    LootBoxAction["SET_CAMPAIGN_DETAILS"] = "set_campaign_details";
})(LootBoxAction = exports.LootBoxAction || (exports.LootBoxAction = {}));
